export const MarketplaceStatuses = {
	Upcoming: 'upcoming',
	Current: 'current',
	Past: 'past',
};
